import { render, staticRenderFns } from "./admissioncollegeandmajorsearch.vue?vue&type=template&id=c9351ece&scoped=true&"
import script from "./admissioncollegeandmajorsearch.vue?vue&type=script&lang=js&"
export * from "./admissioncollegeandmajorsearch.vue?vue&type=script&lang=js&"
import style0 from "./admissioncollegeandmajorsearch.vue?vue&type=style&index=0&id=c9351ece&scoped=true&lang=less&"
import style1 from "./admissioncollegeandmajorsearch.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9351ece",
  null
  
)

export default component.exports